import "./checkanimation.css";

const CheckAnimation = () => {

  return (
    <>
      <div className="contenedor-check">
        <svg viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="45" />
          <path className="checkmark" d="M 25 50 L 43 68 L 75 32" /></svg>
      </div>
    </>
  )
}

export default CheckAnimation;